<style lang="less" scoped>
/*@import "../../style/common.less";*/
@import "../../style/color.less";
@import "../../style/button.css";
/*@import "../../style/greenStyle.less";*/
/*@import "../../style/custom.less";*/
/*@import "../../style/components.less";*/
/*@import "../../style/uniform.default.min.less";*/

.flex-1 {
	flex: 1;
}

.flex-2 {
	flex: 2;
}

.date1 {
	width: 150px;
	height: 38px;
}

.fcc_bgpg {
	/*background: url("../../img/footer_logo_fcc.svg")no-repeat;*/
	/*z-index:1;*/
	/*background-position: 95%;*/
}

.logoPG {
	width: 20%;
	height: 150px;
	float: right;
	margin-top: 10px;
	margin-bottom: 10px;
	border: 1px red solid;
	/*position: relative;*/
	/*right: 100px;*/
	/*bottom: 100px;*/
}

.like_instNo {
	float: left;
	width: 290px;
	height: 50px;
}

.like_input {
	float: left;
	width: 230px;
	height: 50px;
}

.like_input2 {
	float: left;
	width: 160px;
	height: 50px;
}

.firstRow {
	float: left;
	height: 50px;
	//border: 1px black solid;
	width: 100%;
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}

.secondRow {
	float: left;
	height: 320px;
	width: 100%;
	//border: 1px blue solid;
	//margin-top: 10px;
	//margin-bottom: 10px;
	/*width: 1000px;*/
}

.thirdRow {
	float: left;
	height: 60px;
	width: 100%;
	//border: 1px black solid;
	margin-top: 10px;
	//margin-bottom: 5px;
	/*width: 1000px;*/
}

.fourthRow {
	float: left;
	height: 20px;
	width: 100%;
	//border: 1px black solid;
	//margin-top: 10px;
	//margin-bottom: 10px;
	/*width: 1000px;*/
}

.requiredArea {
	float: left;
	//margin-top: 10px;
	width: 48%;
	//width: 1300px;
	height: 200px;
	margin-bottom: 10px;
	border: 2px black solid;
	/*background: url("../../img/fccLOGO.png")no-repeat;*/
	/*background-position: 85%;*/
	/*border: 1px red solid;*/
}

.noRequiredArea {
	float: right;
	//margin-top: 10px;
	width: 48%;
	//width: 1300px;
	height: 315px;
	margin-bottom: 10px;
	margin-right: 10px;
	border: 2px yellowgreen solid;
	/*background: url("../../img/fccLOGO.png")no-repeat;*/
	/*background-position: 85%;*/
	/*border: 1px red solid;*/
}

.refuseArea {
	float: left;
	margin-top: 5px;
	width: 48%;
	//width: 1300px;
	height: 100px;
	border: 2px red solid;
	/*background: url("../../img/fccLOGO.png")no-repeat;*/
	/*background-position: 85%;*/
	/*border: 1px red solid;*/
}

.textRows {
	float: left;
	height: 30px;
	border: 1px black solid;
	width: 100%;
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}

.inputRows {
	float: left;
	height: 50px;
	border: 1px black solid;
	width: 100%;
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}

.reasonRows {
	float: left;
	height: 80px;
	border: 1px black solid;
	width: 100%;
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}

.like_date {
	float: left;
	width: 650px;
	height: 50px;
}

.like_cust {
	float: left;
	width: 450px;
	height: 50px;
}

.min-320 {
	min-width: 320px;
}

.min-540 {
	min-width: 540px;
}

.min-520 {
	min-width: 500px;
}

.min-680 {
	min-width: 680px;
}

.min-220 {
	min-width: 220px;
}

.inline-block {
	display: inline-block;
}

.query-div-select {
	width: 150px;
}

.label-control {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	color: yellowgreen;
}

/*.el-table {
	background: linear-gradient(to right, #092a9c, #0c5692) !important ;
}*/
.form-control {
	background-color: white !important;
}

span.query-title-span {
	display: inline-block;
	width: 80px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 10px;
	color: black;
}

span.queryMust-title-span {
	display: inline-block;
	width: 90px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: red;
}

span.query-title-line {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	text-align: center;
	width: 30px;
	color: yellowgreen;
}

/*.portlet.light{*/
/*	background: linear-gradient(to right, #092a9c, #0c5692) !important ;*/
/*}*/
.query-div-input-date {
	width: 150px;
}

.query-div {
	// border: 1px solid #ddd;
	padding: 16px 0;
	border-radius: 4px;
}

.margin-left-8 {
	margin-left: 8px;
}

.draw-enter-active, .draw-leave-active {
	transition: all 1s ease;
}

.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
	height: 0;
	overflow: hidden;
}

.uploadImg {
	width: 100%;
	height: 1.5rem;
	position: relative;

	input {
		width: 1.46rem;
		height: 100%;
		z-index: 1;
		opacity: 0;
		position: absolute;
		cursor: pointer;
	}
}

span.limitNum {
	display: inline-block;
	width: 280px;
	font-size: 17px;
	font-weight: 700;
	text-align: center;
	/*margin-left: 20px;*/
	color: black;
}
</style>
<style lang="less">
.dialog-input-text .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	font-weight: bold;
}

//数字靠右
.dialog-input-text2 .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	text-align: right;
}

.el-date-table {
	font-size: 18px;
}

.el-date-table tr td:first-child {
	color: #CE4040;
}

.el-date-table tr td:last-child {
	color: #8DEF56;
}

span.query-title-span3 {
	display: inline-block;
	width: 60px;
	font-size: 14px;
	font-weight: 550;
	text-align: right;
	margin-right: 5px;
	color: black;
}

span.query-title-span2 {
	display: inline-block;
	width: 90px;
	font-size: 12px;
	font-weight: 700;
	text-align: left;
	margin-right: 20px;
}

span.text-span3 {
	display: inline-block;
	width: 300px;
	font-size: 12px;
	font-weight: 800;
	text-align: left;
	margin-left: 30px;
}

span.text-span4 {
	display: inline-block;
	//width: 60px;
	font-size: 14px;
	font-weight: 550;
	text-align: center;
	margin-right: 5px;
	margin-left: 10px;
	color: black;
}
</style>
<template>
	<div class="iot-vue-container">
		<!-- 标题组件 -->
		<!--		<div class="vue-header">-->
		<!--			<div class="vue-header-title-div">-->
		<!--				<span class="vue-header-title" @click="init()">&nbsp;&nbsp;{{ pageTitle }}</span>-->
		<!--			</div>-->
		<!--			<div class="vue-header-breadcrumb">-->
		<!--				&lt;!&ndash;<Breadcrumb>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.mainPage}">首页</BreadcrumbItem>-->
		<!--					<BreadcrumbItem>{{sysCfg.modules.null}}</BreadcrumbItem>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.tRealtimeFillin.name_en}">{{sysCfg.tRealtimeFillin.name}}</BreadcrumbItem>-->
		<!--			   </Breadcrumb>&ndash;&gt;-->
		<!--			</div>-->
		<!--		</div>-->
		<div class="vue-main">
			<div class="fcc_bgpg">
				<!--查询条件 -->
				<div class="firstRow">
					<div class="like_instNo">
						<span class="query-title-span" style="color: red">询价明细号</span>
						<el-input type="text" style="width: 150px" v-model="queryParam.kbRqstDNo"/>
					</div>
					<div class="like_input" style="width: 210px">
						<span class="query-title-span">部品编号</span>
						<el-input :disabled="true" type="text" style="width: 110px" v-model="queryParam.itmCode"/>
					</div>
					<div class="like_instNo" style="width: 230px">
						<span class="query-title-span">部品名称</span>
						<el-input :disabled="true" type="text" style="width: 130px" v-model="queryParam.itmName"/>
					</div>
					<div class="like_input2">
						<span class="query-title-span" style="width: 60px">种类</span>
						<el-input :disabled="true" type="text" style="width: 80px" v-model="queryParam.kbRqstType"/>
					</div>
					<div class="like_input2" style="width: 180px">
						<span class="query-title-span" style="width: 60px">状态</span>
						<el-input :disabled="true" type="text" style="width: 100px"
								  v-model="queryParam.inqConfirmStatusNm"/>
					</div>
					<el-button type="primary" class="button button-glow button-rounded button-royal"
							   v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append"
							   @click="getList('query')">查询
					</el-button>

				</div>

				<!--				<div class="firstRow">-->

				<!--				<div class="logoPG">-->
				<!--					<img src="../../img/footer_logo_fcc.svg" width="140px" height="150px" style="margin-left: 10px"/>-->
				<!--				</div>-->
				<!--操作功能区 -->
				<div class="secondRow">
					<div class="requiredArea">
						<el-row>
							<el-col :span="24">
								<div style="margin-bottom: 10px">
									<span class="query-title-span2" style="color: red">必填区域</span>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">包装费</span>
									<el-input type="text" style="width: 120px" @change="checkPckgFyValue(headInfo.pckgFy)" v-model="headInfo.pckgFy"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">运费</span>
									<el-input type="text" style="width: 120px" @change="checkYunfeiValue(headInfo.yunfei)" v-model="headInfo.yunfei"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">管理费</span>
									<el-input type="text" style="width: 120px" @change="checkGlFyValue(headInfo.glFy)" v-model="headInfo.glFy"/>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">利润</span>
									<el-input type="text" style="width: 120px" @change="checkLirunValue(headInfo.lirun)" v-model="headInfo.lirun"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">税率</span>
									<el-input type="text" style="width: 120px" @change="checkTaxrateValue(headInfo.taxrate)" v-model="headInfo.taxrate"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">发票类别</span>
									<el-select v-model="headInfo.invTyp" filterable style="width: 120px"
											   placeholder="请选择">
										<el-option
											v-for="item in invTypList"
											:key="item.invTyp"
											:label="item.invTypNm"
											:value="item.invTyp">
										</el-option>
									</el-select>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">作成者</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.spplUserPho"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">确认者</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.spplComfPho"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">承认者</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.spplRecoPho"/>
								</div>
							</el-col>
						</el-row>

					</div>

					<div class="noRequiredArea">
						<el-row>
							<el-col :span="24">
								<div style="margin-bottom: 10px">
									<span class="query-title-span2">选填区域</span>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">支给@</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.defray"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">加工@</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.process"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">受入@</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.receive"/>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">实施年月</span>
									<el-date-picker value-format="yyyy-MM-dd" type="month"
													class="query-div-select inline-block"
													v-model="headInfo.putYM" style="width: 120px" :editable="false"
													placeholder="选择月份">
									</el-date-picker>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">现行单价</span>
									<el-input type="text" style="width: 120px" @change="checkUpriValue(headInfo.upri)" v-model="headInfo.upri"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">设定台数</span>
									<el-input type="text" style="width: 120px"  @change="checkSetTowerQtyValue(headInfo.setTowerQty)" v-model="headInfo.setTowerQty"/>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<div class="like_date">
									<span class="query-title-span3">备注</span>
									<el-input type="text" style="width: 450px" v-model="headInfo.remark" maxlength="100"/>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<div style="margin-bottom: 10px">
									<span class="text-span3">年次原価低減</span>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">2年目</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.reduceYear1"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">3年目</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.reduceYear2"/>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="like_input">
									<span class="query-title-span3">4年目</span>
									<el-input type="text" style="width: 120px" v-model="headInfo.reduceYear3"/>
								</div>
							</el-col>
						</el-row>

					</div>
					<div class="refuseArea">
						<el-row>
							<el-col :span="24">
								<div style="margin-bottom: 10px">
									<span class="query-title-span2">拒绝报价理由</span>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<div style="margin-bottom: 10px">
									<span
										class="text-span4">{{ refuseReason }}</span>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
				<!--操作功能区 -->
				<div class="thirdRow">
					<div class="actions-div  margin-bottom-10">
						<div class="btns-div margin-top-10">
							<el-button type="primary"
									   class="button button-glow button-raised button-raised button-primary"
									   @click="addRow"><i class="fa fa-plus"></i>添加行
							</el-button>
							<el-button type="primary" style="margin-right: 10px"
									   class="button button-glow button-rounded button-caution"
									   @click="checkForDelete"><i class="fa fa-trash-o fa-fw"></i>删除行
							</el-button>
							<el-checkbox style="margin-right: 1px" v-model="jgfFlg" :true-label="'1'"
										 :false-label="'0'"></el-checkbox>
							<el-button type="primary" style="margin-right: 10px"
									   class="button button-glow button-rounded button-highlight"
									   @click="openJgf"><i class="fa fa-window-maximize"></i>加工费
							</el-button>
							<el-checkbox v-model="mjfFlg" :true-label="'1'" :false-label="'0'"></el-checkbox>
							<el-button type="primary" class="button button-glow button-rounded button-highlight"
									   @click="openMjf"><i class="fa fa-window-maximize"></i>模具费
							</el-button>
							<el-button type="primary" class="button button-glow button-rounded button-royal"
									   @click="getQtnInfoUpload"><i class="fa fa-cloud-upload"></i>上传附件
							</el-button>
						</div>
						<div class="pull-right margin-top-10">
							<!--搜索区 -->
							<el-button type="primary" class="button button-glow button-rounded button-caution"
									   @click="beforeRefuse"><i class="fa fa-times"></i>拒绝报价
							</el-button>
							<el-button type="primary" class="button button-glow button-rounded button-royal"
									   @click="getExcelUpload"><i class="fa fa-file-excel-o"></i>Excel模板导入
							</el-button>
							<el-button type="primary" class="button button-glow button-rounded button-action"
									   @click="checkForSave"><i class="fa fa-check"></i>登录
							</el-button>
						</div>
						<p class="uploadImg" hidden="true">
							<input multiple type="file" ref="myfile" id="myfile" @change="getQtnInfoFile">
						</p>
						<p class="uploadImg" hidden="true">
							<input multiple type="file" ref="excelfile" id="excelfile" @change="getExcelFile">
						</p>
						<el-dialog
							title="删除行"
							:visible.sync="dialogVisibleDelete"
							width="30%">
							<span>确认删除吗？</span>
							<span slot="footer">
									<el-button @click="dialogVisibleDelete = false">取 消</el-button>
									<el-button type="primary" @click="checkedDelete">确 定</el-button>
								</span>
						</el-dialog>
						<el-dialog
							title="拒绝报价"
							:visible.sync="dialogVisibleRefuse"
							width="30%">
							<span style="font-size: large;color: indianred">请输入拒绝理由</span>
							<el-input
								type="textarea"
								:rows="5"
								placeholder="请输入内容"
								v-model="headInfo.refuseReason">
							</el-input>
							<span slot="footer">
									<el-button @click="dialogVisibleRefuse = false">取 消</el-button>
									<el-button type="primary" @click="refuseSave">提 交</el-button>
								</span>
						</el-dialog>
						<el-dialog
							title="报价回复登录"
							:visible.sync="dialogVisibleSave"
							width="30%">
							<span>确认要提交报价回复信息吗</span>
							<span slot="footer">
						<el-button @click="dialogVisibleSave = false">取 消</el-button>
						<el-button type="primary" @click="checkedSave">确 定</el-button>
					  </span>
						</el-dialog>
					</div>
				</div>
				<div class="fourthRow">
					<span
						style="display: inline-block;width: 300px;font-size: 13px;font-weight: 700;text-align: left;margin-right: 20px;">材料费合计:{{
							sumMoney
						}}</span>
				</div>
			</div>
			<!--表格区-->
			<el-table :data="listData" ref="multipleTable" :row-style="rowStyle"
					  @selection-change="handleSelectionChange"
					  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor" border row-key="id"
					  :height="400">
				<el-table-column type="selection" align="center" width="40"></el-table-column>
				<el-table-column prop="material" v-if="qtnType == '1'" label="材质" align="center" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.material"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="size" v-if="qtnType == '1'" label="尺寸" align="center" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.size"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="blank" v-if="qtnType == '1'" label="毛坯(g)" align="left" min-width="160">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.blank"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkBlankValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="finishProd" v-if="qtnType == '1'" label="成品(g)" align="center" min-width="160">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.finishProd"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="finishRate" v-if="qtnType == '1'" label="成品率" align="center" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.finishRate"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkFinishRateValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="kg" v-if="qtnType == '1'" label="@/kg" align="left" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.kg"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkKgValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="fWkg" v-if="qtnType == '1'" label="废料W(g)" align="center" min-width="60">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.fWkg"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkFWkgValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="fKg" v-if="qtnType == '1'" label="废料(@/kg)" align="center" min-width="60">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.fKg"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkFKgValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="materialCost" v-if="qtnType == '1'" label="材料费" align="center" min-width="60">
					<template slot-scope="scope">
						<span align="center">{{ scope.row.materialCost }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="spec" v-if="qtnType == '2'" label="制品名称" min-width="115" align="center">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.spec"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="prodNm" v-if="qtnType == '2'" label="规格" align="left" min-width="120">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.prodNm"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="qty" v-if="qtnType == '2'" label="数量" align="left" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.qty"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkQtyValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="unitCd" v-if="qtnType == '2'" label="单位" align="left" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.unitCd"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="unitPrice" v-if="qtnType == '2'" label="单价(不含税)" align="left"
								 min-width="120">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.unitPrice"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkUnitPriceValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="money" v-if="qtnType == '2'" label="金额(不含税)" align="left" min-width="120">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.money"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkMoneyValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="purCycle" v-if="qtnType == '2'" label="采购周期" align="left" min-width="100">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.purCycle"
								  align="center" class="dialog-input-text" maxlength="40"
								  @change="checkPurCycleValue(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="brand" v-if="qtnType == '2'" label="品牌" align="left" min-width="120">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.brand"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="remark" v-if="qtnType == '2'" label="备考" align="center" min-width="200">
					<template slot-scope="scope">
						<el-input size="small" type="text" v-model="scope.row.remark"
								  align="center" class="dialog-input-text" maxlength="40"></el-input>
					</template>
				</el-table-column>
			</el-table>

			<!--表格区-->
			<!--加工费登录 -->
			<el-dialog title="加工费登录" :visible.sync="dialogVisibleByJgf" :close-on-click-modal="false">
				<div class="dialog-overflow iot-form">
					<Form ref="formDisFrom" :model="formJgfInfo">
						<div class="formUserInfo">
							<FormItem>
								<div class="pull-left">
									<el-button type="primary"
											   class="button button-glow button-raised button-raised button-primary"
											   @click="addJgfRow"><i class="fa fa-plus"></i>添加行
									</el-button>
									<el-button type="primary" style="margin-right: 10px"
											   class="button button-glow button-rounded button-caution"
											   @click="checkForDeleteJgf"><i class="fa fa-trash-o fa-fw"></i>删除行
									</el-button>
									<el-button type="primary" class="button button-glow button-rounded button-action"
											   @click="checkSaveJgf"><i class="fa fa-check"></i>登录
									</el-button>
								</div>
								<!--								<div class="pull-right">-->
								<!--									<el-button type="primary" class="button button-glow button-rounded button-action"-->
								<!--											   @click="checkForSave"><i class="fa fa-check"></i>登录-->
								<!--									</el-button>-->
								<!--								</div>-->
							</FormItem>
							<div class="fourthRow">
								<span
									style="display: inline-block;width: 300px;font-size: 13px;font-weight: 700;text-align: left;margin-right: 20px;">加工费合计:{{ sumJgf }}</span>
							</div>
							<!--表格区-->
							<el-table height="300px" ref="multipleTableJgf" :data="formJgfInfo.dialogByJgfList"
									  border
									  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor"
									  @selection-change="handleSelectionChangeJgf">
								<el-table-column type="selection" align="center" width="40" fixed></el-table-column>
								<el-table-column prop="prodIntExtTyp" label="内外区分"
												 min-width="150">
									<template slot-scope="scope">
										<el-select v-model="scope.row.prodIntExtTyp" filterable style="width: 130px"
												   placeholder="请选择">
											<el-option
												v-for="item in extTypList"
												:key="item.extTyp"
												:label="item.extTypNm"
												:value="item.extTyp">
											</el-option>
										</el-select>
										<!--										<el-input class="dialog-input-text" v-model="scope.row.prodIntExtTyp" maxlength="14" ></el-input>-->
									</template>
								</el-table-column>
								<el-table-column prop="kouteiNm" label="工程名" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.kouteiNm"
												  maxlength="14"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="machin" label="使用机械" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.machin"
												  maxlength="14"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="workHour" label="工数" min-width="100">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.workHour" maxlength="40"
												  @change="checkWorkHourValue(scope.row)"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="feiyong" label="费用" min-width="120">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.feiyong" maxlength="40"
												  @change="checkFeiyongValue(scope.row)"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="processFy" label="加工费" min-width="120">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.processFy" maxlength="40"
												  @change="checkProcessFyValue(scope.row)"></el-input>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</Form>
				</div>
			</el-dialog>
			<!--模具费登录 -->
			<el-dialog title="模具费登录" :visible.sync="dialogVisibleByMjf" :close-on-click-modal="false">
				<div class="dialog-overflow iot-form">
					<Form ref="formDisFrom" :model="formMjfInfo">
						<div class="formUserInfo">
							<FormItem>
								<div class="pull-left">
									<el-button type="primary"
											   class="button button-glow button-raised button-raised button-primary"
											   @click="addMjfRow"><i class="fa fa-plus"></i>添加行
									</el-button>
									<el-button type="primary" style="margin-right: 10px"
											   class="button button-glow button-rounded button-caution"
											   @click="checkForDeleteMjf"><i class="fa fa-trash-o fa-fw"></i>删除行
									</el-button>
									<el-button type="primary" class="button button-glow button-rounded button-action"
											   @click="checkSaveMjf"><i class="fa fa-check"></i>登录
									</el-button>
								</div>
								<!--								<div class="pull-right">-->
								<!--									<el-button type="primary" class="button button-glow button-rounded button-action"-->
								<!--											   @click="checkForSave"><i class="fa fa-check"></i>登录-->
								<!--									</el-button>-->
								<!--								</div>-->
							</FormItem>
							<div class="fourthRow">
								<span
									style="display: inline-block;width: 300px;font-size: 13px;font-weight: 700;text-align: left;margin-right: 20px;">金额合计:{{ sumMjf }}</span>
							</div>
							<!--表格区-->
							<el-table height="300px" ref="multipleTableMjf" :data="formMjfInfo.dialogByMjfList"
									  :stripe="true" border
									  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor"
									  @selection-change="handleSelectionChangeMjf">
								<el-table-column type="selection" align="center" width="40" fixed></el-table-column>
								<el-table-column prop="moldNm" label="名称" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.moldNm"
												  maxlength="40"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="assetAcc" label="资材台账 登录NO."
												 min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.assetAcc"
												  maxlength="40"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="setQty" label="设定数" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.setQty" maxlength="40"
												  @change="checkSetQtyValue(scope.row)"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="moldCount" label="保证命数" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.moldCount" maxlength="40"
												  @change="checkMoldCountValue(scope.row)"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="moldAmt" label="金额" min-width="150">
									<template slot-scope="scope">
										<el-input class="dialog-input-text" v-model="scope.row.moldAmt" maxlength="40"
												  @change="checkMoldAmtValue(scope.row)"></el-input>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</Form>
				</div>
			</el-dialog>
			<!--分页区 -->
		</div>
	</div>
</template>
<script>
import config from '@/config/config.js';
import moment from 'moment';
import {mapActions} from "vuex";
import httpUtil from "../../utils/httpUtil";
import api from "../../config/apiConfig";
import axios from 'axios';
import Da from "element-ui/src/locale/lang/da";
import {isNumeric} from "echarts/lib/util/number";

export default {
	data() {
		return {
			pageTitle: '采购信息一览',
			sysCfg: config,
			listData: [],
			invTypList: [],
			pageParams: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			queryParam: {
				kbRqstDNo: '',
				itmCode: '',
				itmName: '',
				kbRqstType: '',
				inqConfirmStatusNm: '',
				spplCd: '',
				pageNum: 0,
				pageSize: 10
			},
			refuseReason: '',//画面拒绝报价理由
			headInfo: {
				pckgFy: '',
				yunfei: '',
				glFy: '',
				lirun: '',
				taxrate: '',
				invTyp: '',
				spplUserPho: '',
				spplComfPho: '',
				spplRecoPho: '',

				defray: '',
				process: '',
				receive: '',
				putYM: '',
				upri: '',
				setTowerQty: '',
				remark: '',
				reduceYear1: '',
				reduceYear2: '',
				reduceYear3: '',
				refuseReason: '',//弹窗拒绝报价理由
			},
			extTypList: [
				{
					extTyp: '0',
					extTypNm: '内',
				},
				{
					extTyp: '1',
					extTypNm: '外',
				}

			],
			searchVal: '',
			fullscreenLoading: false,
			dialogVisibleSave: false,
			dialogVisibleDelete: false,
			dialogVisibleRefuse: false,
			dialogVisibleByJgf: false,
			dialogVisibleByMjf: false,
			multipleSelection: [],
			multipleSelectionJgf: [],
			multipleSelectionMjf: [],
			disableFlg: false,
			insideFlg: false,
			jgfFlg: '1',
			mjfFlg: '1',
			qtnType: '2',//报价区分，1构成件，2消耗品
			formJgfInfo: {
				dialogByJgfList: [],
			},
			formMjfInfo: {
				dialogByMjfList: [],
			},
			sumMoney: 0,
			sumMjf: 0,
			sumJgf: 0,
		};
	},
	methods: {
		...mapActions("tab", ["reflush"]),
		init() {
			var _this = this;
			// 数据初始化
			_this.searchVal = '';
			var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
			if (currUser.userType == '1') {//自公司用户
				_this.insideFlg = true;
			} else if (currUser.userType == '2') {//供应商用户
				_this.queryParam.spplCd = currUser.spplCd;
				_this.insideFlg = false;
				_this.disableFlg = true;
			}
			this.getInvTypList();
			this.deleteTmpJgfByUser();
			this.deleteTmpMjfByUser();
			if (this.$route.query.kbRqstDNo != undefined) {
				_this.queryParam.kbRqstDNo = this.$route.query.kbRqstDNo;
				_this.queryParam.spplCd = this.$route.query.spplCd;
				_this.qtnType = this.$route.query.qtnType;
				_this.getList();
			}

		},

		// 获取发票类别列表
		getInvTypList() {
			this.invTypList = this.$sdnJob.invTypList();
		},

		//删除加工费临时表信息
		deleteTmpJgfByUser() {
			var _this = this;
			_this.$httpUtil.ajaxPost(_this, _this.$api.tQuotation.deleteTmpJgfByUser, null, function (res) {
				return;
			});
		},

		//删除模具费临时表信息
		deleteTmpMjfByUser() {
			var _this = this;
			_this.$httpUtil.ajaxPost(_this, _this.$api.tQuotation.deleteTmpMjfByUser, null, function (res) {
				return;
			});
		},

		// 获取列表
		getList(val) {
			var _this = this;
			if (_this.queryParam.kbRqstDNo == null || _this.queryParam.kbRqstDNo == undefined || _this.queryParam.kbRqstDNo == '') {
				_this.$util.error('请输入询价明细号');
				return;
			}
			this.fullscreenLoading = true;
			_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.findQuotation, _this.queryParam, function (response) {
				_this.fullscreenLoading = false;
				if (response.data.data.status == 200) {
					var quotationDto = response.data.data.data;
					var inquiryEntity = quotationDto.inquiryEntity;
					_this.queryParam.kbRqstDNo = inquiryEntity.kbRqstDNo;
					_this.queryParam.itmCode = inquiryEntity.itmCode;
					_this.queryParam.itmName = inquiryEntity.itmName;
					_this.qtnType = inquiryEntity.kbRqstType;
					if (inquiryEntity.kbRqstType == '1') {
						_this.queryParam.kbRqstType = '构成件';
					} else {
						_this.queryParam.kbRqstType = '消耗品';
					}

					_this.queryParam.inqConfirmStatusNm = _this.getInqConfirmStatusNm(inquiryEntity.inqConfirmStatus);
					_this.refuseReason = inquiryEntity.refuseReason;

					var quotationEntity = quotationDto.quotationEntity;
					_this.headInfo = quotationEntity;
					_this.listData = quotationDto.detailList;
					_this.sumMoney = quotationDto.sumDetailMoney;
					_this.formJgfInfo.dialogByJgfList = quotationDto.jgfList;
					_this.formMjfInfo.dialogByMjfList = quotationDto.mjfList;
				} else if (response.data.data.status == 2) {//无数据
					var quotationDto = response.data.data.data;
					var inquiryEntity = quotationDto.inquiryEntity;
					_this.queryParam.kbRqstDNo = inquiryEntity.kbRqstDNo;
					_this.queryParam.itmCode = inquiryEntity.itmCode;
					_this.queryParam.itmName = inquiryEntity.itmName;
					_this.qtnType = inquiryEntity.kbRqstType;
					if (inquiryEntity.kbRqstType == '1') {
						_this.queryParam.kbRqstType = '构成件';
					} else {
						_this.queryParam.kbRqstType = '消耗品';
					}
					_this.queryParam.inqConfirmStatusNm = _this.getInqConfirmStatusNm(inquiryEntity.inqConfirmStatus);
					_this.refuseReason = inquiryEntity.refuseReason;

					_this.headInfo = {};
					_this.listData = [];
					_this.formJgfInfo.dialogByJgfList = [];
					_this.formMjfInfo.dialogByMjfList = [];
				} else {
					_this.$util.error(response.data.data.message);
				}
				//重新渲染table布局，解决fixed错位
				_this.$nextTick(() => {
					_this.$refs.multipleTable.doLayout();
				});
			});
		},

		getInqConfirmStatusNm(status){
			if (status == '0'){
				return '未查看';
			}
			if (status == '1'){
				return '已查看';
			}
			if (status == '2'){
				return '已报价';
			}
			if (status == '3'){
				return '拒绝';
			}
			if (status == '4'){
				return '已完结';
			}
		},

		//表格新增行
		addRow() {
			let _this = this;
			let selected = this.multipleSelection;
			let listAll = this.listData;
			let indexOld = 0;
			let list;
			if (selected == null || selected == undefined || selected == '') {
				if (this.qtnType == '1') {
					list = {
						material: '',
						size: '',
						blank: 0,
						finishProd: '',
						finishRate: 0,
						kg: 0,
						fWkg: 0,
						fKg: 0,
						materialCost: 0,
					}
				}
				if (this.qtnType == '2') {
					list = {
						index: '',
						spec: '',
						prodNm: '',
						qty: '',
						unitCd: '',
						unitPrice: '',
						money: 0,
						purCycle: '',
						brand: '',
						remark: '',
					}
				}
				this.listData.push(list);
			} else if (selected.length > 1) {
				_this.$util.error('只能选中一条明细复制');
				return;
			} else {
				selected.forEach((val, index) => {
					listAll.forEach((v, i) => {
						if (val.id == v.id) {
							indexOld = i;
						}
					})
					if (this.qtnType == '1') {
						list = {
							index: indexOld + 1,
							material: val.material,
							size: val.size,
							blank: val.blank,
							finishProd: val.finishProd,
							finishRate: val.finishRate,
							kg: val.kg,
							fWkg: val.fWkg,
							fKg: val.fKg,
							materialCost: val.materialCost,
						}
					}
					if (this.qtnType == '2') {
						list = {
							index: indexOld + 1,
							spec: val.spec,
							prodNm: val.prodNm,
							qty: val.qty,
							unitCd: val.unitCd,
							unitPrice: val.unitPrice,
							money: val.money,
							purCycle: val.purCycle,
							brand: val.brand,
							remark: val.remark,
						}
					}
					//原选中行后追加数据
					this.listData.splice(indexOld + 1, 0, list);
					// 原选中行设为取消选中
					this.$refs.multipleTable.toggleRowSelection(selected[0], false);
					// 复制行设为选中
					this.$refs.multipleTable.toggleRowSelection(this.listData[indexOld + 1], true);
				});
			}
		},

		addJgfRow() {
			let _this = this;
			let selected = this.multipleSelectionJgf;
			let listAll = this.formJgfInfo.dialogByJgfList;
			let indexOld = 0;
			let list;
			if (selected == null || selected == undefined || selected == '') {
				list = {
					prodIntExtTyp: '',
					kouteiNm: '',
					machin: '',
					workHour: '',
					feiyong: '',
					processFy: '',
				}
				this.formJgfInfo.dialogByJgfList.push(list);
			} else if (selected.length > 1) {
				_this.$util.error('只能选中一条明细复制');
				return;
			} else {
				selected.forEach((val, index) => {
					listAll.forEach((v, i) => {
						if (val.id == v.id) {
							indexOld = i;
						}
					})
					list = {
						index: indexOld + 1,
						prodIntExtTyp: val.prodIntExtTyp,
						kouteiNm: val.kouteiNm,
						machin: val.machin,
						workHour: val.workHour,
						feiyong: val.feiyong,
						processFy: val.processFy,
					}

					//原选中行后追加数据
					this.formJgfInfo.dialogByJgfList.splice(indexOld + 1, 0, list);
					// 原选中行设为取消选中
					this.$refs.multipleTableJgf.toggleRowSelection(selected[0], false);
					// 复制行设为选中
					this.$refs.multipleTableJgf.toggleRowSelection(this.formJgfInfo.dialogByJgfList[indexOld + 1], true);
				});
			}
		},


		addMjfRow() {
			let _this = this;
			let selected = this.multipleSelectionMjf;
			let listAll = this.formMjfInfo.dialogByMjfList;
			let indexOld = 0;
			let list;
			if (selected == null || selected == undefined || selected == '') {
				list = {
					moldNm: '',
					assetAcc: '',
					setQty: '',
					moldCount: '',
					moldAmt: '',
				}
				this.formMjfInfo.dialogByMjfList.push(list);
			} else if (selected.length > 1) {
				_this.$util.error('只能选中一条明细复制');
				return;
			} else {
				selected.forEach((val, index) => {
					listAll.forEach((v, i) => {
						if (val.id == v.id) {
							indexOld = i;
						}
					})
					list = {
						index: indexOld + 1,
						moldNm: val.moldNm,
						assetAcc: val.assetAcc,
						setQty: val.setQty,
						moldCount: val.moldCount,
						moldAmt: val.moldAmt,
					}

					//原选中行后追加数据
					this.formMjfInfo.dialogByMjfList.splice(indexOld + 1, 0, list);
					// 原选中行设为取消选中
					this.$refs.multipleTableMjf.toggleRowSelection(selected[0], false);
					// 复制行设为选中
					this.$refs.multipleTableMjf.toggleRowSelection(this.formMjfInfo.dialogByMjfList[indexOld + 1], true);
				});
			}
		},

		checkForDelete() {
			let _this = this;
			let selected = this.multipleSelection;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('未选中任何数据');
				return;
			}
			this.dialogVisibleDelete = true;
		},
		// // 选中删除
		// checkedDelete() {
		// 	let _this = this;
		// 	let selected = this.multipleSelection;
		// 	//将选中行中id不为空的对象放入新的数组
		// 	let newSLC = selected.filter((item, i) => {
		// 		if (item.id !== null && item.id !== undefined && item.id !== '') {
		// 			this.listData.forEach((val, i) => {
		// 				if (item.id == val.id) {
		// 					this.listData.splice(i, 1);
		// 				}
		// 			})
		// 			return item;
		// 		} else {
		// 			this.listData.forEach((val, i) => {
		// 				if (item.index == val.index) {
		// 					this.listData.splice(i, 1);
		// 				}
		// 			})
		// 		}
		// 	});
		// 	//去掉空行后的新数组若为空，则刷新页面，显示有效数据
		// 	if (newSLC == null || newSLC == undefined || newSLC == '') {
		// 		this.dialogVisibleDelete = false;
		// 		return;
		// 	}
		// 	//将有效数据数组（待删除）赋值给原数组
		// 	selected = newSLC;
		// 	_this.$httpUtil.ajaxPut(this, _this.$api.tForecastSalesMonth.checkedDelete, selected, function (res) {
		// 		if (res.data.data.status == 200) {
		// 			_this.$util.success(res.data.data.message);
		// 			// _this.getList();
		// 		} else {
		// 			_this.$util.error(res.data.data.message);
		// 		}
		// 	});
		// 	this.dialogVisibleDelete = false;
		// },
		// 选中删除
		checkedDelete() {
			let _this = this;
			let selected = this.multipleSelection;
			//将选中行中id不为空的对象放入新的数组
			let newSLC = selected.filter((item, i) => {
				if (item.id !== null && item.id !== undefined && item.id !== '') {
					this.listData.forEach((val, i) => {
						if (item.id == val.id) {
							item.isDel = 'Y';
							this.listData.splice(i, 1);
						}
					})
				} else {
					this.listData.forEach((val, i) => {
						if (item.index == val.index) {
							this.listData.splice(i, 1);
						}
					})
				}
				return item;
			});

			console.log('newSLC',newSLC);//newSLC为待删除数组
			this.dialogVisibleDelete = false;
		},

		checkForDeleteJgf() {
			let _this = this;
			let selected = this.multipleSelectionJgf;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('未选中任何数据');
				return;
			}
			//将选中行中id不为空的对象放入新的数组
			let newSLC = selected.filter((item, i) => {
				if (item.id !== null && item.id !== undefined && item.id !== '') {
					_this.formJgfInfo.dialogByJgfList.forEach((val, i) => {
						if (item.id == val.id) {
							item.isDel = 'Y';
							_this.formJgfInfo.dialogByJgfList.splice(i, 1);
						}
					})
				} else {
					_this.formJgfInfo.dialogByJgfList.forEach((val, i) => {
						if (item.index == val.index) {
							_this.formJgfInfo.dialogByJgfList.splice(i, 1);
						}
					})
				}
				return item;
			});
			console.log('MjfNewSLC',newSLC);//newSLC为待删除数组
		},

		checkForDeleteMjf() {
			let _this = this;
			let selected = this.multipleSelectionMjf;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('未选中任何数据');
				return;
			}
			//将选中行中id不为空的对象放入新的数组
			let newSLC = selected.filter((item, i) => {
				if (item.id !== null && item.id !== undefined && item.id !== '') {
					_this.formMjfInfo.dialogByMjfList.forEach((val, i) => {
						if (item.id == val.id) {
							item.isDel = 'Y';
							_this.formMjfInfo.dialogByMjfList.splice(i, 1);
						}
					})
				} else {
					_this.formMjfInfo.dialogByMjfList.forEach((val, i) => {
						if (item.index == val.index) {
							_this.formMjfInfo.dialogByMjfList.splice(i, 1);
						}
					})
				}
				return item;
			});
			console.log('JgfNewSLC',newSLC);//newSLC为待删除数组
		},

		checkForSave() {
			let _this = this;
			if (_this.queryParam.kbRqstDNo == null || _this.queryParam.kbRqstDNo == undefined || _this.queryParam.kbRqstDNo == '') {
				_this.$util.error('请输入询价明细号');
				return;
			}
			//必填区域检查
			let formInfo = this.headInfo;
			if (formInfo.pckgFy == null || formInfo.pckgFy == undefined || formInfo.pckgFy == '') {
				_this.$util.error('请输入包装费');
				return;
			}
			if (formInfo.yunfei == null || formInfo.yunfei == undefined || formInfo.yunfei == '') {
				_this.$util.error('请输入运费');
				return;
			}
			if (formInfo.glFy == null || formInfo.glFy == undefined || formInfo.glFy == '') {
				_this.$util.error('请输入管理费');
				return;
			}
			if (formInfo.lirun == null || formInfo.lirun == undefined || formInfo.lirun == '') {
				_this.$util.error('请输入利润');
				return;
			}
			if (formInfo.taxrate == null || formInfo.taxrate == undefined || formInfo.taxrate == '') {
				_this.$util.error('请输入税率');
				return;
			}
			if (formInfo.invTyp == null || formInfo.invTyp == undefined || formInfo.invTyp == '') {
				_this.$util.error('请输入发票类别');
				return;
			}
			if (formInfo.spplUserPho == null || formInfo.spplUserPho == undefined || formInfo.spplUserPho == '') {
				_this.$util.error('请输入作成者');
				return;
			}
			if (formInfo.spplComfPho == null || formInfo.spplComfPho == undefined || formInfo.spplComfPho == '') {
				_this.$util.error('请输入确认者');
				return;
			}
			if (formInfo.spplRecoPho == null || formInfo.spplRecoPho == undefined || formInfo.spplRecoPho == '') {
				_this.$util.error('请输入承认者');
				return;
			}

			//明细区域检查
			let selected = this.listData;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('无新增明细');
				return;
			}

			let flag = false;
			selected.some(function (item) {
				if (_this.qtnType == '1') {
					if (item.material == null || item.material == undefined || item.material == '') {
						_this.$util.error('请输入材质');
						return flag = true;
					}
					if (item.size == null || item.size == undefined || item.size == '') {
						_this.$util.error('请输入尺寸');
						return flag = true;
					}
					if (item.blank == null || item.blank == undefined || item.blank == '') {
						_this.$util.error('请输入毛坯(g)');
						return flag = true;
					}
					if (item.finishProd == null || item.finishProd == undefined || item.finishProd == '') {
						_this.$util.error('请输入成品(g)');
						return flag = true;
					}
					if (item.finishRate == null || item.finishRate == undefined || item.finishRate == '') {
						_this.$util.error('请输入成品率');
						return flag = true;
					}
					if (item.kg == null || item.kg == undefined || item.kg == '') {
						_this.$util.error('请输入@/kg');
						return flag = true;
					}
					if (item.fWkg == null || item.fWkg == undefined || item.fWkg == '') {
						_this.$util.error('请输入废料W(g)');
						return flag = true;
					}
					if (item.fKg == null || item.fKg == undefined || item.fKg == '') {
						_this.$util.error('请输入废料(@/kg)');
						return flag = true;
					}
				}

				if (_this.qtnType == '2') {
					if (item.spec == null || item.spec == undefined || item.spec == '') {
						_this.$util.error('请输入制品名称');
						return flag = true;
					}
					if (item.prodNm == null || item.prodNm == undefined || item.prodNm == '') {
						_this.$util.error('请输入规格');
						return flag = true;
					}
					if (item.qty == null || item.qty == undefined || item.qty == '') {
						_this.$util.error('请输入数量');
						return flag = true;
					}
					if (item.unitCd == null || item.unitCd == undefined || item.unitCd == '') {
						_this.$util.error('请输入单位');
						return flag = true;
					}
					if (item.unitPrice == null || item.unitPrice == undefined || item.unitPrice == '') {
						_this.$util.error('请输入单价(不含税)');
						return flag = true;
					}
					if (item.money == null || item.money == undefined || item.money == '') {
						_this.$util.error('请输入金额(不含税)');
						return flag = true;
					}
					if (item.purCycle == null || item.purCycle == undefined || item.purCycle == '') {
						_this.$util.error('请输入采购周期');
						return flag = true;
					}
					if (item.brand == null || item.brand == undefined || item.brand == '') {
						_this.$util.error('请输入品牌');
						return flag = true;
					}
				}
			});

			if (flag) {
				return;
			}

			//弹窗明细检查
			if (this.jgfFlg == '1') {
				if (this.formJgfInfo.dialogByJgfList.length == 0) {
					_this.$util.error('加工费未填写,若不需要,请取消勾选加工费按钮前的勾选框');
					return;
				}
			}
			if (this.mjfFlg == '1') {
				if (this.formMjfInfo.dialogByMjfList.length == 0) {
					_this.$util.error('模具费未填写,若不需要,请取消模具费按钮前的勾选框');
					return;
				}
			}
			this.dialogVisibleSave = true;
		},

		checkedSave() {
			let _this = this;
			let param = {
				kbRqstDNo: _this.queryParam.kbRqstDNo,
				spplCd: _this.queryParam.spplCd,
				quotationEntity: _this.headInfo,
				detailList: _this.listData,
				jgfList : _this.formJgfInfo.dialogByJgfList,
				mjfList : _this.formMjfInfo.dialogByMjfList,
			};
			_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.checkedSave, param, function (res) {
				if (res.data.data.status == 200) {
					_this.$util.success(res.data.data.message);
					_this.getList();
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
			this.dialogVisibleSave = false;
		},

		//拒绝报价
		beforeRefuse() {
			let _this = this;
			if (_this.queryParam.kbRqstDNo == null || _this.queryParam.kbRqstDNo == undefined || _this.queryParam.kbRqstDNo == '') {
				_this.$util.error('请输入询价明细号');
				return;
			}
			_this.dialogVisibleRefuse = true;
		},

		refuseSave() {
			let _this = this;
			if (_this.headInfo.refuseReason == null || _this.headInfo.refuseReason == undefined || _this.headInfo.refuseReason == '') {
				_this.$util.error('请输入拒绝理由');
				return;
			}
			let param = {
				kbRqstDNo: _this.queryParam.kbRqstDNo,
				spplCd: _this.queryParam.spplCd,
				refuseReason: _this.headInfo.refuseReason,
			};
			_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.refuseSave, param, function (res) {
				if (res.data.data.status == 200) {
					_this.$util.success(res.data.data.message);
					_this.getList();
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
			this.dialogVisibleRefuse = false;
		},

		checkSaveJgf() {
			let _this = this;
			//明细区域检查
			let selected = _this.formJgfInfo.dialogByJgfList;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('无新增明细');
				return;
			}
			let flag = true;

			selected.some(function (item) {
				if (flag && (item.prodIntExtTyp == null || item.prodIntExtTyp == undefined || item.prodIntExtTyp == '')) {
					_this.$util.error('请选择内外区分');
					return flag = false;
				}
				if (flag && (item.kouteiNm == null || item.kouteiNm == undefined || item.kouteiNm == '')) {
					_this.$util.error('请输入工程名');
					return flag = false;
				}
				if (flag && (item.machin == null || item.machin == undefined || item.machin == '')) {
					_this.$util.error('请输入使用机械');
					return flag = false;
				}
				if (flag && (item.workHour == null || item.workHour == undefined || item.workHour == '')) {
					_this.$util.error('请输入工数');
					return flag = false;
				}
				if (flag && (item.feiyong == null || item.feiyong == undefined || item.feiyong == '')) {
					_this.$util.error('请输入费用');
					return flag = false;
				}
				if (flag && (item.processFy == null || item.processFy == undefined || item.processFy == '')) {
					_this.$util.error('请输入加工费');
					return flag = false;
				}

			});
			if (flag) {
				_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.checkSaveJgf, selected, function (res) {
					if (res.data.data.status == 200) {
						_this.$util.success(res.data.data.message);
					} else {
						_this.$util.error2(res.data.data.message);
					}
				});
			}
		},

		checkSaveMjf() {
			let _this = this;
			//明细区域检查
			let selected = this.formMjfInfo.dialogByMjfList;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('无新增明细');
				return;
			}

			let flag = true;
			selected.some(function (item) {
				if (flag && (item.moldNm == null || item.moldNm == undefined || item.moldNm == '')) {
					_this.$util.error('请输入名称');
					return flag = false;
				}
				if (flag && (item.setQty == null || item.setQty == undefined || item.setQty == '')) {
					_this.$util.error('请输入设定数');
					return flag = false;
				}
				if (flag && (item.moldCount == null || item.moldCount == undefined || item.moldCount == '')) {
					_this.$util.error('请输入保证命数');
					return flag = false;
				}
				if (flag && (item.moldAmt == null || item.moldAmt == undefined || item.moldAmt == '')) {
					_this.$util.error('请输入金额');
					return flag = false;
				}

			});

			if (flag) {
				_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.checkSaveMjf, selected, function (res) {
					if (res.data.data.status == 200) {
						_this.$util.success(res.data.data.message);
					} else {
						_this.$util.error2(res.data.data.message);
					}
				});
			}
		},

		// 打开加工费弹窗
		openJgf() {
			var _this = this;
			_this.getTmpJgfList();
		},

		getTmpJgfList() {
			var _this = this;
			let param = {
				kbRqstDNo: _this.queryParam.kbRqstDNo,
				spplCd: _this.queryParam.spplCd,
			};
			_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.getJgfList, param, function (response) {
				if (response.data.data.status == 200) {
					_this.formJgfInfo.dialogByJgfList = response.data.data.data;
					_this.sumJgf = response.data.data.message;
				}else {
					_this.formJgfInfo.dialogByJgfList = [];
				}
				_this.dialogVisibleByJgf = true;
			});
		},

		// 打开模具费弹窗
		openMjf() {
			var _this = this;
			_this.getTmpMjfList();
		},

		getTmpMjfList() {
			var _this = this;
			let param = {
				kbRqstDNo: _this.queryParam.kbRqstDNo,
				spplCd: _this.queryParam.spplCd,
			};
			_this.$httpUtil.ajaxPost(this, _this.$api.tQuotation.getMjfList, param, function (response) {
				if (response.data.data.status == 200) {
					_this.formMjfInfo.dialogByMjfList = response.data.data.data;
					_this.sumMjf = response.data.data.message;
				}else {
					_this.formMjfInfo.dialogByMjfList = [];
				}
				_this.dialogVisibleByMjf = true;
			});
		},

		getExcelFile() {
			this.toExcelUpload();
		},

		getExcelUpload() {
			this.$refs.excelfile.dispatchEvent(new MouseEvent('click'));
		},

		//Excel文件上传
		toExcelUpload() {
			let url = this.$api.tQuotation.toExcelImport;
			let excelfile = this.$refs.excelfile;
			let files = excelfile.files;
			let file = files[0];
			let formData = new FormData();
			let type = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (!(type == "xlsx")) {
				this.$util.error("文件格式有误，仅可上传xlsx格式的文件");
				document.getElementById('excelfile').value = "";
				return;
			}
			formData.append("file", file);
			let token = this.$cookie.get('slash_token');
			const loading = this.$loading({
				lock: true,
				text: '导入中，请等待...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$axios({
				method: "post",
				url: url,
				timeout: 300000,
				headers: {
					// 'Content-type': 'multipart/form-data',
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': token
				},
				data: formData,
			}).then(
				res => {
					if (res) {
						loading.close();
						if (res.data.status == 200) {
							this.$util.success2(res.data.message);
							this.queryParam.kbRqstDNo = res.data.data.kbRqstDNo;
							if (this.queryParam.spplCd == '') {
								this.queryParam.spplCd = res.data.data.spplCd;
							}
							this.getList();
						} else {
							this.$util.error2(res.data.message);
						}
					}
					document.getElementById('excelfile').value = "";
				}, err => {
					loading.close();
					this.$util.error('上传失败');
				});
			return;
		},

		//上传按钮动作
		getQtnInfoFile() {
			this.toQtnInfoUpload();
		},

		//触发隐藏的上传按钮,导入
		getQtnInfoUpload() {
			let _this = this;
			if (_this.queryParam.kbRqstDNo == null || _this.queryParam.kbRqstDNo == undefined || _this.queryParam.kbRqstDNo == '') {
				_this.$util.error('请输入询价明细号');
				return;
			}
			this.$refs.myfile.dispatchEvent(new MouseEvent('click'));
		},

		//文件上传
		toQtnInfoUpload() {
			let url = this.$api.tQuotation.toQtnUpload;
			let myfile = this.$refs.myfile;
			let files = myfile.files;
			let file = files[0];
			let formData = new FormData();
			let type = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (!(type == "pdf" || type == "zip")) {
				this.$util.error("文件格式有误，仅可上传pdf、zip格式的文件");
				document.getElementById('myfile').value = "";
				return;
			}
			formData.append("file", file);
			formData.append("kbRqstDNo", this.queryParam.kbRqstDNo);
			formData.append("spplCd", this.queryParam.spplCd);
			formData.append("fileName", file.name);
			let token = this.$cookie.get('slash_token');
			const loading = this.$loading({
				lock: true,
				text: '上传中，请等待...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$axios({
				method: "post",
				url: url,
				timeout: 300000,
				headers: {
					// 'Content-type': 'multipart/form-data',
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': token
				},
				data: formData,
			}).then(
				res => {
					if (res) {
						loading.close();
						if (res.data.status == 200) {
							this.$util.success2(res.data.message);
							// this.getList();
						} else {
							this.$util.error2(res.data.message);
						}
					}
					document.getElementById('myfile').value = "";
				}, err => {
					loading.close();
					this.$util.error('上传失败');
				});
			return;
		},

		checkPckgFyValue(pckgFy) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(pckgFy) || num1.test(pckgFy))) {
				this.headInfo.pckgFy = '';
				return;
			}
		},

		checkYunfeiValue(yunfei) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(yunfei) || num1.test(yunfei))) {
				this.headInfo.yunfei = '';
				return;
			}
		},

		checkGlFyValue(glFy) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(glFy) || num1.test(glFy))) {
				this.headInfo.glFy = '';
				return;
			}
		},

		checkLirunValue(lirun) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(lirun) || num1.test(lirun))) {
				this.headInfo.lirun = '';
				return;
			}
		},

		checkTaxrateValue(taxrate) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(taxrate) || num1.test(taxrate))) {
				this.headInfo.taxrate = '';
				return;
			}
		},

		checkUpriValue(upri) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(upri) || num1.test(upri))) {
				this.headInfo.upri = '';
				return;
			}
		},

		checkSetTowerQtyValue(setTowerQty) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(setTowerQty) || num1.test(setTowerQty))) {
				this.headInfo.setTowerQty = '';
				return;
			}
		},


		getSumMoney1() {
			let selected = this.listData;
			let sumMoney = 0;
			selected.some(function (item) {
				if (item.materialCost != 0 && item.materialCost != '' && item.materialCost != undefined) {
					var materialCost = parseFloat(item.materialCost);
					sumMoney = sumMoney + materialCost;
				}
			});
			sumMoney = sumMoney.toFixed(4);
			this.sumMoney = sumMoney.replace(/(\.\d*?[1-9])0+$/, '$1');
			return;
		},

		getSumMoney2() {
			let selected = this.listData;
			let sumMoney = 0;
			selected.some(function (item) {
				if (item.money != 0 && item.money != '' && item.money != undefined) {
					var money = parseFloat(item.money);
					sumMoney = sumMoney + money;
				}
			});
			sumMoney = sumMoney.toFixed(4);
			this.sumMoney = sumMoney.replace(/(\.\d*?[1-9])0+$/, '$1');
			return;
		},

		getMaterialCost(blank, kg, fWkg, fkg) {
		// getMaterialCost(blank, kg, finishRate, fWkg, fkg) {
			//update by duan 20241227
			// let materialCost = (blank / 1000 * kg * finishRate) - (fWkg * fkg);
			let materialCost = (blank / 1000 * kg) - (fWkg / 1000 * fkg);
			materialCost = materialCost.toFixed(4);
			return materialCost;
		},

		checkBlankValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.blank) || num1.test(row.blank))) {
				row.blank = '';
				return;
			}
			if (row.blank != '' && row.kg != '' && row.fWkg != '' && row.fKg != '' && row.blank != undefined && row.kg != undefined && row.fWkg != undefined && row.fKg != undefined) {
				row.materialCost = this.getMaterialCost(row.blank, row.kg, row.fWkg, row.fKg);
			}
			this.getSumMoney1();
		},

		checkFinishRateValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.finishRate) || num1.test(row.finishRate))) {
				row.finishRate = '';
				return;
			}

			// if (row.blank != '' && row.kg != '' && row.fWkg != '' && row.fKg != '') {
			// 	row.materialCost = this.getMaterialCost(row.blank, row.kg, row.finishRate, row.fWkg, row.fKg);
			// }
			// this.getSumMoney1();
		},

		checkKgValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.kg) || num1.test(row.kg))) {
				row.kg = '';
				return;
			}

			if (row.blank != '' && row.kg != '' && row.fWkg != '' && row.fKg != '') {
				row.materialCost = this.getMaterialCost(row.blank, row.kg, row.fWkg, row.fKg);
			}
			this.getSumMoney1();
		},

		checkFWkgValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.fWkg) || num1.test(row.fWkg))) {
				row.fWkg = '';
				return;
			}

			if (row.blank != '' && row.kg != '' && row.fWkg != '' && row.fKg != '') {
				row.materialCost = this.getMaterialCost(row.blank, row.kg, row.fWkg, row.fKg);
			}
			this.getSumMoney1();
		},

		checkFKgValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.fKg) || num1.test(row.fKg))) {
				row.fKg = '';
				return;
			}

			if (row.blank != '' && row.kg != '' && row.fWkg != '' && row.fKg != '') {
				row.materialCost = this.getMaterialCost(row.blank, row.kg, row.fWkg, row.fKg);
			}
			this.getSumMoney1();
		},

		checkQtyValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.qty) || num1.test(row.qty))) {
				row.qty = '';
				return;
			}
		},

		checkUnitPriceValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.unitPrice) || num1.test(row.unitPrice))) {
				row.unitPrice = '';
				return;
			}
		},

		checkMoneyValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.money) || num1.test(row.money))) {
				row.money = '';
				return;
			}
			this.getSumMoney2();
		},

		checkPurCycleValue(row) {
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!num1.test(row.purCycle)) {
				row.unitPrice = '';
				return;
			}
		},

		checkWorkHourValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.workHour) || num1.test(row.workHour))) {
				row.workHour = '';
				return;
			}
		},

		checkFeiyongValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.feiyong) || num1.test(row.feiyong))) {
				row.feiyong = '';
				return;
			}
		},

		checkProcessFyValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.processFy) || num1.test(row.processFy))) {
				row.processFy = '';
				return;
			}
			this.getSumJgf();
		},

		getSumJgf() {
			let selected = this.formJgfInfo.dialogByJgfList;
			let sumJgf = 0;
			selected.some(function (item) {
				if (item.processFy != 0 && item.processFy != '' && item.processFy != undefined) {
					var money = parseFloat(item.processFy);
					sumJgf = sumJgf + money;
				}
			});
			sumJgf = sumJgf.toFixed(4);
			this.sumJgf = sumJgf.replace(/(\.\d*?[1-9])0+$/, '$1');
			return;
		},

		checkSetQtyValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.setQty) || num1.test(row.setQty))) {
				row.setQty = '';
				return;
			}
		},

		checkMoldCountValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.moldCount) || num1.test(row.moldCount))) {
				row.moldCount = '';
				return;
			}
		},

		checkMoldAmtValue(row) {
			var num = /^(\d{0,9}\.\d{0,4})$/;//number(13,4)的正则表达式
			var num1 = /^\d{0,9}$/;//9位长度的数字正则表达式
			if (!(num.test(row.moldAmt) || num1.test(row.moldAmt))) {
				row.moldAmt = '';
				return;
			}
			this.getSumMjf();
		},

		getSumMjf() {
			let selected = this.formMjfInfo.dialogByMjfList;
			let sumMjf = 0;
			selected.some(function (item) {
				if (item.moldAmt != 0 && item.moldAmt != '' && item.moldAmt != undefined) {
					var money = parseFloat(item.moldAmt);
					sumMjf = sumMjf + money;
				}
			});
			sumMjf = sumMjf.toFixed(4);
			this.sumMjf = sumMjf.replace(/(\.\d*?[1-9])0+$/, '$1');
			return;
		},

		//设置表格行的样式
		tableRowStyle({row, column, rowIndex, columnIndex}) {
			return "border: 1px solid black !important;color:black;font-size:16px;padding: 7px 0;"
		},
		//设置表头行的样式
		tableHeaderColor({row, column, rowIndex, columnIndex}) {
			return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #CCCCCC !important;color:black;padding: 7px 0;'
		},
		//保存选中结果
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		//保存选中结果 加工费
		handleSelectionChangeJgf(val) {
			this.multipleSelectionJgf = val;
		},
		//保存选中结果 模具费
		handleSelectionChangeMjf(val) {
			this.multipleSelectionMjf = val;
		},
		rowStyle({row, rowIndex}) {
			let arr = this.multipleSelection;
			if (arr != null && arr.length > 0) {
				for (let i = 0; i < arr.length; i++) {
					if (row.id == arr[i].id) {
						return {"background-color": "rgba(0, 250, 154, 0.75)"};
					}
				}
			}
		},
	},
	mounted() {
		this.init();

	},
	watch: {}
};
</script>





// WEBPACK FOOTER //
// src/views/tQuotation/List.vue